import React, {useState,useEffect} from 'react';
import { useStyle } from './PrequalStyle.js';
import {
    VALIDATION_TEXT,
    USE_EIRCODE_TEXT,
    checkAvailabilityText,
    EIRCODE_TEXTFIELD_ICON_IMAGE,
} from './Constants.js';
import { Grid, Typography, Button, TextField, Popper } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { useApolloClient } from '@apollo/client';
import { getAddressList } from './EirPrequalIntegration.js';
import { formatAddress, validateEircode } from './EirPrequalUtil';
import { useLocalStorage } from './EirPrequalPersistance';

export default function EirPrequalInputEircode(props) {

    const [isEircodeEmpty, setEircodeEmpty] = useState(false);
    const [isEirCodeValid, setIsEirCodeValid] = useState(true);
    const [disableButton, setDisableButton] = useState(true);
    const [open, setOpen] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [prequalAddressObject, setPrequalAddressObject] = useState({});
    const [eirCode, setEirCode] = useState('');
    const { setLocalStorage,getLocalStorage } = useLocalStorage();
    
    const classes = useStyle();
    const graphql = useApolloClient();
    const handleEircodeChange = value => {
        if (!value || value.length < 7) {
            setOpen(false);
            setIsEirCodeValid(true);
            setDisableButton(true);
        }
        if (value.length > 0) {
            setEircodeEmpty(false);
        }
        setAddressList(value);
    };

    //function to return dummy object to append for address not found
    const getAddressValidationMessage = () => {
        return [
            {
                addressLine1: `${USE_EIRCODE_TEXT.text}`,
            },
        ];
    }

    const setAddressList = async function (eirCode) {
        let validEircode;
        let addressNotFound = getAddressValidationMessage(eirCode);
        if (eirCode && eirCode.length >= 7) {
            validEircode = validateEircode(eirCode);
            if (validEircode.length > 0) {
                setEirCode(validEircode);
                setIsEirCodeValid(true);
                try {
                    let data = await getAddressList(graphql, validEircode);
                    let fullList = [...data.addressList.addresses].map(
                        val => ({
                            ...val,
                            userEnteredEirCode: eirCode, // append user entered input as a property to all the objects in the data fetched from API
                        })
                    );
                    setAddresses(fullList);
                    setOpen(true);
                } catch (err) {
                    setAddresses([...addressNotFound]); // show cant find address when API fails
                }
            } else if (eirCode.length >= 7 && validEircode.length === 0) {
                setIsEirCodeValid(false);
                setAddresses([...addressNotFound]); // show cant find address when eircode length is >=7
            }
        } else {
            setOpen(false);
            setDisableButton(true);
            setAddresses([...addressNotFound]); // show cant find address when eircode length is less than 7
        }
    };
    const CustomPopper = (props) => {
        return <Popper {...props} className={classes.AutocompleteListItems} placement='bottom' />;
    };
    const filterOptions = createFilterOptions({
        stringify: option => option.userEnteredEirCode, // filter based on eircode entered by user, was earlier filtering by eircode returned from API
    });

    //method for fomatting the selected address, into a particualar object
    const createAddressObject = address => {
        let obj;
        obj = {
            eircode: eirCode ? eirCode : address.eircode,
        };
        if (address.county) {
            let county = address.county.replace('CO_', '');

            obj = { ...obj, ...{ county: county } };
        } else obj = { ...obj, ...{ county: '' } };

        if (address.town) obj = { ...obj, ...{ town: address.town } };
        else obj = { ...obj, ...{ town: '' } };

        if (address.addressLine1) obj = { ...obj, ...{ addressLine1: address.addressLine1 } };
        else obj = { ...obj, ...{ addressLine1: '' } };

        if (address.addressLine2) obj = { ...obj, ...{ addressLine2: address.addressLine2 } };
        else obj = { ...obj, ...{ addressLine2: '' } };

        if (address.addressLine3) obj = { ...obj, ...{ addressLine3: address.addressLine3 } };
        else obj = { ...obj, ...{ addressLine3: '' } };

        setPrequalAddressObject({
            ...obj,
        });
    };

    //on click of check availablity, set the localstorage and route to /shop/broadband
     const checkAvailability = () => {
        const prequalAddress = {
          'addressLine1': prequalAddressObject.addressLine1,
          'addressLine2': prequalAddressObject.addressLine2,
          'addressLine3': prequalAddressObject.addressLine3,
          'county': prequalAddressObject.county,
          'town': prequalAddressObject.town,
          'eircode': prequalAddressObject.eircode
        }
        setLocalStorage('R6_PREQUAL_ADDRESS', prequalAddress);
        setLocalStorage('ls_district', prequalAddressObject.town);
        setLocalStorage('ls_county', prequalAddressObject.county);
        setLocalStorage('ls_prequalby', 'eircode');
        window.location.href = '/shop/broadband';
    };
     useEffect(() => {
        //getting the context from the url
        let currentContext = window.location.pathname.slice(1);
        let queryString = window.location.search.substring(1) !== '' && `?${window.location.search.substring(1)}` || '' ;
        //when first time pages other than broadband or tv loads
        if (!getLocalStorage('currentContext')) {
            setLocalStorage('currentContext', currentContext);
        }

        else if (window.location.pathname.includes(getLocalStorage('currentContext')) === false)
            setLocalStorage('currentContext', currentContext);

        //when page comed back from /results it will get the context from localstorage and set the virtual url
        if (getLocalStorage('currentContext')) {
            let cont = getLocalStorage('currentContext');
           window.history.pushState({}, '', window.location.origin + `/${cont}`  + queryString);
        }
    }, []);
    return (
        <div>
            <Grid className={classes.CTAInputContainer}>
                <div className={classes.CTAInputBox}>
                    <Autocomplete
                        id='eircode'
                        className={classes.AutocompleteTextField}
                        options={addresses}
                        open={open}
                        clearOnBlur={false}
                        noOptionsText='No Addresses Found'
                        PopperComponent={CustomPopper}
                        onChange={(event, value) => {
                                setOpen(false); // to close dropdown when user selects a address from dropdown
                                setDisableButton(false);
                                createAddressObject(value);
                                setOpen(false);
                        }}
                        getOptionLabel={option => {
                            return formatAddress(option);
                        }}
                        renderOption={option => {
                                setEircodeEmpty(false);
                                // render address fetched from API with proper formatting
                                return formatAddress(option);
                        }}
                        filterOptions={filterOptions}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant='outlined'
                                placeholder='Enter your Eircode'
                                className={
                                    isEircodeEmpty ? classes.CTAInputEmpty : classes.CTAInput
                                }
                                error={!isEirCodeValid}
                                onChange={e => {
                                    handleEircodeChange(e.target.value);
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <img
                                            src={EIRCODE_TEXTFIELD_ICON_IMAGE}
                                            className={classes.TextFieldIconImage}
                                        />
                                    ),
                                    endAdornment: null,
                                }}
                            />
                        )}></Autocomplete>
                    {!isEirCodeValid && (
                        <Typography
                            className={classes.EircodeValidity}
                            >
                            {VALIDATION_TEXT.eircodeValidation}
                        </Typography>
                    )}
                    {isEircodeEmpty && (
                        <Typography
                            className={classes.EircodeValidity}
                            >
                            {VALIDATION_TEXT.eircodeRequired}
                        </Typography> 
                    )}
                </div>
                <Button
                    id='check_via_eircode'
                    className={
                        classes.CTAButton + ' ' + (!isEirCodeValid && classes.CTAButtonExtraMargin)
                    }
                    disabled={disableButton}
                    onClick={() => {
                        checkAvailability();
                    }}>
                    {checkAvailabilityText}
                </Button>
            </Grid>
        </div>
    );
}